import { ShaderDataType } from "../../DriverDesign/RenderDevice/ShaderData";
export class WebGLUniformBufferBase {
    setInt(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view[0] = value;
            this.needUpload = true;
        }
    }
    setFloat(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view[0] = value;
            this.needUpload = true;
        }
    }
    setVector2(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view[0] = value.x;
            uniform.view[1] = value.y;
            this.needUpload = true;
        }
    }
    setVector3(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view[0] = value.x;
            uniform.view[1] = value.y;
            uniform.view[2] = value.z;
            this.needUpload = true;
        }
    }
    setVector4(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view[0] = value.x;
            uniform.view[1] = value.y;
            uniform.view[2] = value.z;
            uniform.view[3] = value.w;
            this.needUpload = true;
        }
    }
    setMatrix3x3(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            let element = value.elements;
            for (let i = 0; i < 3; i++) {
                for (let j = 0; j < 3; j++) {
                    uniform.view[i * 4 + j] = element[i * 3 + j];
                }
            }
            this.needUpload = true;
        }
    }
    setMatrix4x4(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view.set(value.elements);
            this.needUpload = true;
        }
    }
    setBuffer(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            uniform.view.set(value);
            this.needUpload = true;
        }
    }
    setArrayBuffer(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            let arrayLength = uniform.arrayLength;
            let size = uniform.size;
            let alignStride = uniform.alignStride;
            for (let i = 0; i < arrayLength; i++) {
                uniform.view.set(value.subarray(i * size, (i + 1) * size), i * alignStride);
            }
            this.needUpload = true;
        }
    }
    setMatrix3x3Array(index, value) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            let arrayLength = uniform.arrayLength;
            let size = uniform.size;
            let alignStride = uniform.alignStride;
            for (let i = 0; i < arrayLength; i++) {
                for (let j = 0; j < 3; j++) {
                    for (let k = 0; k < 3; k++) {
                        uniform.view[i * alignStride + j * 4 + k] = value[i * 9 + j * 3 + k];
                    }
                }
            }
            this.needUpload = true;
        }
    }
    setUniformData(index, type, data) {
        let uniform = this.descriptor.uniforms.get(index);
        if (uniform) {
            switch (type) {
                case ShaderDataType.Bool:
                    console.warn("ShaderDataType.Bool not support");
                    break;
                case ShaderDataType.Int:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setInt(index, data);
                    }
                    break;
                case ShaderDataType.Float:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setFloat(index, data);
                    }
                    break;
                case ShaderDataType.Vector2:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setVector2(index, data);
                    }
                    break;
                case ShaderDataType.Vector3:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setVector3(index, data);
                    }
                    break;
                case ShaderDataType.Vector4:
                case ShaderDataType.Color:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setVector4(index, data);
                    }
                    break;
                case ShaderDataType.Matrix3x3:
                    if (uniform.arrayLength > 0) {
                        this.setMatrix3x3Array(index, data);
                    }
                    else {
                        this.setMatrix3x3(index, data);
                    }
                    break;
                case ShaderDataType.Matrix4x4:
                    if (uniform.arrayLength > 0) {
                        this.setArrayBuffer(index, data);
                    }
                    else {
                        this.setMatrix4x4(index, data);
                    }
                    break;
                case ShaderDataType.Buffer:
                    break;
                case ShaderDataType.None:
                case ShaderDataType.Texture2D:
                case ShaderDataType.Texture3D:
                case ShaderDataType.TextureCube:
                case ShaderDataType.Texture2DArray:
                default:
                    break;
            }
        }
    }
}
